<template>
  <div class="player por ovh unselect" :class="{'full-screen-box': isFullScreen, 'pic-box': picPic}"
       :style="picPosition"
       @mousedown="startMove"
       @mouseup="startMove($event, 1)"
       @mousemove="showControls(undefined, $event)"
       @mouseleave="showControls(0, $event)">
    <div class="is-zcl vat w100 por zi0"
         :style="{paddingTop: aspectStyle + '%'}"
         v-if="isZcl">
      <zcl-player ref="ZclVideoPlayer"
                  api="webVideoPlayer"
                  path="webPlayer"
                  class="w100 h100 poa l0 t0"
                  @load="onPlayerReady"
                  @play="onPlayerPlay"
                  @update="onPlayerTimeUpdate"
                  @pause="onPlayerPause"
                  @stop="onPlayerEnded"
                  :content_id="resourceInfo.content_id"
                  :datafile_id="resourceInfo.datafile_id"
                  :sku_id="resourceInfo.sku_id"></zcl-player>
    </div>
    <video-player class="video-player vjs-custom-skin"
                  v-else
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                  @ready="onPlayerReady"
                  @loadeddata="onPlayerLoadedData"
                  @play="onPlayerPlay"
                  @playing="onPlayerPlaying"
                  @timeupdate="onPlayerTimeUpdate"
                  @pause="onPlayerPause"
                  @ended="onPlayerEnded">
    </video-player>
    <div class="end-box poa w100 h100 t0 l0 flex-col aic jcc lh1" v-if="isPlayEnd">
      <div class="end-replay"><p class="fs16 tac end-text">当前课程已完成学习。</p> 
				<div class="fs16 rePlay pdt5" @click="rePlayVideo">
					<img class="icon-replay" src="../../assets/images/card/icon_replay.png" alt="">
					<p>重播</p>
				</div>
			</div>
      <mine-no-data hidden-text title="为您推荐" :image-width="160" :image-height="94" :width="160"></mine-no-data>
    </div>
    <div class="not-next poa" v-if="notNext">
      <p>当前是最后一个课时了</p>
    </div>
    <div class="bg-play poa w100 h100 l0 t0 csp zi0" @click="play">
      <div class="big-play-btn abs-mc"></div>
    </div>
    <div class="other-slot dn" :class="{'show-ctr': showCtr}">
      <slot name="other"></slot>
    </div>
    <div class="ctr-box poa w100 l0 zi1 pl20 pr20 lh1" :class="{'show-ctr': showCtr}">
      <div class="time-line poa w100 t0 l0 csp" @mousemove="timeLineHover" @mousedown="mouseDownHere" @click="setCurrentTime" ref="time-line">
        <div class="load-time h100 poa t0 l0 zi0" :style="{width: (currentTime / duration * 100 + 4) + '%'}"></div>
        <div class="curr-time h100 poa t0 l0 zi1" :style="{width: circleLeft}"></div>
        <div class="curr-time-num poa h100 t0 zi1" :style="{left: lineHover + 'px'}" @mousemove.stop>
          <label-tip class="abs-c ovh" label-type="zt"
                     :text="Tools.numberToTime(lineHover / boxWidth * duration * 1000, 'mm:ss')"></label-tip>
        </div>
        <div class="curr-time-circle" :style="{left: circleLeft}" @mousedown="circleDown"></div>
      </div>
      <div class="ctr-inner flex jcb aic h100 por" @mousemove="showCtrInner" @mouseleave="showControls(0)">
        <div class="jcb aic flex" :class="'ctr-' + key" v-for="(control, key) in controls" :key="key">
          <div v-for="(ctr, i) in control" :key="i"
               @click="ctrCallback(ctr.type, ctr, key, i)"
               @mousemove="autoHideOptions(undefined, key, i)"
               :class="[ctr.type + '-ctr por ctr-item', ctr.icon ? ctr.icon + '-ico video-icon' : '', {active: activeCtr === key + i, dn: ctr.isHidden}]">
            <span>{{ctr.value}}</span>
            <div class="top-tip dn abs-c wsnw" v-if="ctr.tip">
              <label-tip label-type="zt" :text="ctr.tip"></label-tip>
            </div>
            <div class="ctr-options abs-c wsnw lh1 dn"
                 v-else-if="ctr.options && ctr.options.length">
              <div class="ctr-options-row flex jcc aic"
                   @click.stop="selectOption(opt, ctr)"
                   :class="{active: opt === ctr.value}"
                   v-for="(opt, j) in ctr.options" :key="j">
                <span class="ctr-options-row-inner">{{opt}}</span>
              </div>
            </div>
            <div v-else-if="ctr.type === 'sound'" class="set-sound abs-c wsnw tac" @click.stop>
              <div class="set-sound-inner flex-col aic">
                <div class="sound-value">{{volume}}%</div>
                <df-progress @move="soundProgressMove" v-model="volume" vertical @change="soundChange"
                             class="flex-1"></df-progress>
              </div>
            </div>
            <!-- <div class="set-sound abs-c wsnw dn"
                 @mouseleave="setVolumeStart($event, 1)"
                 @mouseup="setVolumeStart($event, 1)"
                 @mousemove="setVolumeMove"
                 v-else-if="ctr.type === 'sound'" @click.stop>
              <div class="flex-col aic">
                <span>{{(volume * 100).toFixed(0)}}%</span>
                <div class="set-sound-inner flex-col" ref="volumeOut">
                  <span class="flex-1"></span>
                  <div class="after por" ref="volumeBox" :style="{height: volume * 100 + '%'}">
                    <div class="sound-circle abs-c" @mousedown="setVolumeStart"></div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!--<div class="pic-ctr dn">-->
    <div class="pic-ctr" :class="{'w100 h100 l0 t0 poa': picPic}">
      <div class="pic-title poa t0 l0 w100 flex jcb aic">
        <span>按住画面移动小窗</span>
        <i class="video-icon close-ico csp" @click="showPicture('user-close')"></i>
      </div>
      <div class="pic-play poa flex aic jcc" @click="play">
        <i class="video-icon csp" :class="playing ? 'pause-ico' : 'play-ico'"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import 'video.js/dist/video-js.css';
  import {videoPlayer, videojs} from 'vue-video-player';
  import 'videojs-contrib-hls';
  import {mapGetters, mapMutations} from 'vuex';

  export default {
    name: 'VideoInner',
    components: {
      videoPlayer
    },
    props: {
      resourceInfo: {
        type: Object,
        default() {
          return {};
        }
      },
      videoSrc: {
        type: String,
        default: ''
      },
      poster: {
        type: String,
        default: ''
      },
      aspect: {
        type: String,
        default: '16:9'
      },
      defaultFullScreen: {
        type: Boolean,
        default: false,
      },
      multiple: {
        type: Array,
        default() {
          return [2, 1.5, 1.25, 1, 0.75];
        },
      },
      clear: {
        type: Array,
        default() {
          return ['超清', '高清', '标清'];
        },
      },
      rid: {
        type: String,
        default: ''
      },
      cid: {
        type: String,
        default: ''
      },
      initControls: Function,
      isPlayEnd:{
        type: Boolean,
        default: false
      },
      notNext:{
        type: Boolean,
        default: false
      },
			resize:{//右侧栏
        type: Boolean,
        default: false
      },
			videoIsfcous:{//视频是否为聚焦
				type: Boolean,
				default: true
			},
    },
    computed: {
      ...mapGetters(['userInfo']),
      aspectStyle() {
        let aspect = this.aspect.split(':').map(e => +e);
        return aspect[1] / aspect[0] * 100;
      },
      isZcl() {
        return this.resourceInfo.content_id && this.resourceInfo.datafile_id && this.resourceInfo.sku_id;
      },

      // 控件列表
      controls() {
        // stop: 不使用默认操作
        let controls = {
          left: [
            {type: 'play', icon: this.playing ? 'pause' : 'play', tip: this.playing ? '暂停' : '播放'},
            {type: 'next', icon: 'next', tip: '下一集'},
            {type: 'time', value: this.formatTime('$c/$d')}, // $c：当前时间; $s：剩余时间; $d：总时间,
          ],
          right: [
            {type: 'clear', isHidden: this.isZcl, value: this.currClear || '高清', tip: '', options: this.clear},
            {
              type: 'multiple',
              isHidden: this.isZcl,
              value: this.currMultiple || '倍数',
              tip: '',
              options: this.multiple.map(s => s + 'x')
            },
            {type: 'sound', icon: this.volume ? 'sound' : 'no-sound', tip: ''},
            // {type: 'pic', value: 'pic', tip: '画中画'},
            {
              type: 'full-screen',
              icon: 'full-screen',
              tip: this.isFullScreen ? '退出' : '全屏',
              stop: !this.defaultFullScreen,
            },
          ]
        };
        return typeof this.initControls === 'function' && this.initControls(controls, this) || controls;
      },
      // video js 配置对象
      playerOptions() {
        return {
          playbackRates: this.multiple, //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。

          controls: false, // 是否显示播放控件

          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: this.aspect, // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
            {
              withCredentials: false,
              type: this.typeObj[this.videoSrc.split('?')[0].split('.').pop()] || this.defaultVideoType,
              src: this.videoSrc
            }
          ],
          poster: this.poster, //你的封面地址
          width: document.documentElement.clientWidth,
          flash: {hls: {withCredentials: false}},
          html5: {hls: {withCredentials: false}},
          notSupportedMessage: ' ', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true  //全屏按钮
          }
        };
      },
      // 画中画时定位
      picPosition() {
        return this.picPic ? {
          right: this.picRight + 'px',
          bottom: this.picBottom + 'px',
        } : {};
      },
      circleLeft(){
        if(this.isCircleDown){
          return this.lineHover + 'px';
        }else{
          return (this.currentTime / this.duration * 100) + '%';
        }
      }
    },
    data() {
      return {
        picPic: false, // 画中画
        picRight: 100, // 画中画 right px
        picBottom: 50, // 画中画 bottom px
        playing: false, // 是否在播放

        // 地址类型
        typeObj: {
          //你的m3u8地址（必填）application/x-mpegURL
          m3u8: 'application/x-mpegURL',
          //你的mp4地址（必填）video/mp4
          mp4: 'video/mp4',
        },
        defaultVideoType: 'video/mp4', // 默认类型

        player: null, // 播放器对象
        isFullScreen: false, // 是否为全屏状态
        showCtr: false, // 是否正在显示播放控件
        ctrTimer: null, // 自动收起换件定时器
        currentTime: 0, // 当前播放时间 s
        oldCurrentTime: 0,
        duration: 0, // 视频总时长 s
        surplus: 0, // 剩余时长 s
        volume: 100, // 音量 [0, 1]
        isSetVolumeMove: null, // 设置音量dom对象 [0, 1]
        lineHover: 0, // 鼠标在进度条上的位置 px
        boxWidth: 0, // 当前播放器宽度 px
        activeCtr: '', // 当前活动控件
        currClear: '', // 当前清晰度
        currMultiple: '1x', // 当前播放速度
        activeTimer: null, // 控件的选择列表自动收起定时器
        picObj: null, // 画中画元素dom对象 用于移动

        zclEndTimer: null, // 知传链播放结束事件
        isClear: false,
        isCircleDown: false,
				isMouseDown:false
      }
    },
    watch: {
			resize(){
				// 右侧收起与放出触发
				this.winFullCallback()
			},
		},
    methods: {
			keyDownMethobs(){
				//上下左右空格视频快捷键
				let that = this;
				document.onkeydown = function(e) {   //全屏并按下空格暂停
					e = e || window.event;
					let key = e.keyCode || e.charCode;  
					//事件中keycode=32为空格事件，keycode=37为左方向，keycode=38为上方向，keycode=39为右方向，keycode=40为下方向
					// 非焦点情况下,保留上下方向按钮默认事件
					if(key===32||key === 37||(key === 38 && that.videoIsfcous)||key === 39||(key === 40 && that.videoIsfcous)){
						that.showControls();
						if(e.preventDefault){
								e.preventDefault();
						}else{
								e.returnValue = false;
						}
					}
					if (key === 32) {
						that.play();
					}
					if (key === 37 ) {
						// left
						let currentTime = that.currentTime
						that.currentTime = ((currentTime - 3) > 0) ? currentTime - 3 : 0;
						that.player.currentTime(that.currentTime);
					}
					if (key === 38 && that.videoIsfcous) {
						// up
						clearTimeout(that.activeTimer);
						let val = that.volume;
						that.volume = ((val + 5) < 100) ? val + 5 : 100;
						that.activeCtr = 'right2';
						that.activeTimer = setTimeout(() => {
						  that.autoHideOptions(0);
						}, 2000);
						that.soundChange(that.volume)
					}
					if (key === 39 ) {
						// right
						let currentTime = that.currentTime
						that.currentTime = ((currentTime + 3)< that.duration)? currentTime + 3 : that.duration; 
						that.player.currentTime(that.currentTime);
					}
					if (key === 40 && that.videoIsfcous) {
						// down
						clearTimeout(that.activeTimer);
						let val = that.volume;
						that.volume = ((val-5) > 0 ) ? val-5 : 0
						that.activeCtr = 'right2';
						that.activeTimer = setTimeout(() => {
						  that.autoHideOptions(0);
						}, 2000);
						that.soundChange(that.volume)
					}
				};
			},
      // 移动画中画 开始/结束
      startMove(event, end) {
				if(event&&event.type ==='mouseup' &&this.isMouseDown===true){
					this.isMouseDown = false;
				}
        if (!this.picPic) return this.picObj = null;
        this.picObj = end ? null : this.$el;
      },
      // 画中画
      showPicture(config = {}) {
        if (config === 'user-close') {
          this.$emit(config);
          config = false;
        }
        if (config === false) {
          this.picPic = false;
          // document.exitPictureInPicture();
        } else if (this.player && config.windows) {
          let video = this.player.el_.children[0];
          config.enter && video.addEventListener('enterpictureinpicture', config.enter);
          config.leave && video.addEventListener('leavepictureinpicture', config.leave);
          video.requestPictureInPicture();
        } else if (this.player) {
          this.picPic = true;
        }
      },
      ctrCallback(type, ctr, key, i) {
        if (!ctr.stop) {
          if (ctr.options && ctr.options.length) {
            this.activeCtr = key + i;
            this.autoHideOptions();
          } else if (type === 'play') {
            this.play();
          } else if (type === 'full-screen') {
            this.fullScreen();
          } else if (type === 'pic') {
            this.showPicture(!this.picPic);
          } else if (type === 'sound') {
            this.volume = +!this.volume *100;
            // this.setVolume();
            
            this.soundChange(this.volume);
          }
        }

        this.$emit('ctr-callback', type, ctr, key, i, this);
      },
      selectOption(opt, ctr) {
        if (!ctr.stop) {
          ctr.value = opt;
          if (ctr.type === 'multiple') {
            this.setRate(opt);
          } else if (ctr.type === 'clear') {
            this.currClear = opt;
            this.oldCurrentTime = this.currentTime;
            this.$emit('change-clear', opt);
          }
          this.autoHideOptions(0);
        }
        this.$emit('select-option', opt, ctr, this);
      },
      autoHideOptions(time = 500, key, i) {
        clearTimeout(this.activeTimer);
        if (!time) {
          this.activeTimer = null;
          this.activeCtr = '';
        } else {
          this.activeCtr = key + i;
          this.activeTimer = setTimeout(() => {
            this.autoHideOptions(0);
          }, time);
        }
      },
      formatTime(format) {
        let {currentTime, duration, surplus} = this;
        return format.replace('$c', this.Tools.numberToTime(currentTime * 1000, 'mm:ss'))
          .replace('$d', this.Tools.numberToTime(duration * 1000, 'mm:ss'))
          .replace('$s', this.Tools.numberToTime(surplus * 1000, 'mm:ss'));
      },
      circleUp(e){
        setTimeout(()=>{
          this.isCircleDown = false;
        },500)
      },
      circleDown(e){
        this.isCircleDown = true;
        document.addEventListener('mouseup', this.circleUp);
      },
      timeLineHover(e) {
        let timeLine = this.$refs['time-line'].getBoundingClientRect();
        let el = e.target.getBoundingClientRect();
        this.lineHover = e.offsetX + el.left - timeLine.left;
      },
			mouseDownHere(e){
				// 点击进度条,开启视频范围内拉动
				this.isMouseDown = true;
			},
			rePlayVideo(){
				if(this.isPlayEnd){
					this.$emit('rePlayVideo')
				}
			},
      onPlayerReady(player) {
        player = this.isZcl ? this.$refs.ZclVideoPlayer[0] || this.$refs.ZclVideoPlayer : player;
        this.$emit('ready', player);
        if (this.isZcl) {
          this.onPlayerLoadedData(player);
        }
      },
      onPlayerLoadedData(player) {
        this.player = player;
        if (this.isZcl) {
          this.duration = this.resourceInfo.total;
          this.volume = player.volume * 100;
        } else {
          this.duration = player.duration();
          if(+this.volume < 100){
            // 如果音量不是100说明手动改过，这时候播放视频需要重新设置一下
            this.volume = this.volume;
            this.soundChange(this.volume);
          }else{
            this.volume = player.volume() * 100;
          }
          if (this.oldCurrentTime) {
            this.currentTime = this.oldCurrentTime;
            this.player.currentTime(this.oldCurrentTime);
            this.oldCurrentTime = 0;
          }
          this.setRate(this.currMultiple);
        }
        this.currentTime = 0;
        this.playing = false;
        if (this.userInfo.uid) {
          this.addRecord();
          this.addCourseRecord();
          this.addPlayTimes();
        }
        this.$emit('load', player);
      },
      // 设置音量
      soundProgressMove(val){
        this.volume = +val.toFixed(0);
      },
      soundChange(val){
        if (this.isZcl) {
          this.player.emitPlayer('setVolume', (+val / 100));
        } else {
          this.player && this.player.volume((+val / 100));
        }
      },
      // setVolumeStart(event, end) {
      //   if (end) {
      //     this.isSetVolumeMove && this.setVolume();
      //     this.isSetVolumeMove = null;
      //   } else {
      //     this.isSetVolumeMove = this.$refs.volumeBox[0];
      //   }
      // },
      // setVolumeMove(event) {
      //   if (this.isSetVolumeMove) {
      //     let {movementY} = event;
      //     let {height: H} = this.$refs.volumeOut[0].getBoundingClientRect();
      //     let {height} = this.isSetVolumeMove.getBoundingClientRect();
      //     let volume = (height - movementY) / H;
      //     this.volume = volume < 0 ? 0 : volume > 1 ? 1 : (volume || 0);
      //   }
      // },
      // setVolume(e) {
      //   if (this.isZcl) {
      //     this.player.emitPlayer('setVolume', +this.volume.toFixed(2));
      //   } else {
      //     this.player.volume(+this.volume.toFixed(2));
      //   }
      // },
      setCurrentTime(e) {
        if (this.isZcl) return;
				this.currentTime = (this.lineHover / this.boxWidth * this.duration)
        this.player.currentTime(this.lineHover / this.boxWidth * this.duration);
      },
      boxMove(event) {
        if (this.picObj && this.picPic) {
          let {picRight, picBottom} = this;
          let {clientWidth, clientHeight} = document.body;
          let {offsetWidth, offsetHeight} = this.picObj;
          let min = 0;
          let maxX = clientWidth - offsetWidth;
          let maxY = clientHeight - offsetHeight;
          picRight -= event.movementX;
          picBottom -= event.movementY;
          picRight = Math.max(min, picRight);
          picBottom = Math.max(min, picBottom);
          picRight = Math.min(maxX, picRight);
          picBottom = Math.min(maxY, picBottom);
          this.picRight = picRight;
          this.picBottom = picBottom;
        }
      },
      showCtrInner(){
        this.isClear = true;
        clearTimeout(this.ctrTimer);
      },
      showControls(time = 2000, event) {
				if(event&&event.type==='mouseleave' && this.isMouseDown === true){
					this.isMouseDown = false
				}
				if(event&&event.type==='mousemove' && this.isMouseDown === true){
					let timeLine = this.$refs['time-line'].getBoundingClientRect();
					let el = event.target.getBoundingClientRect();
					this.lineHover = event.offsetX + el.left - timeLine.left;
					this.setCurrentTime();
				}
        if(!time){
          this.isClear = false;
        }
        if(this.isClear){
          return;
        }
        if (this.picPic) {
          time || this.startMove('', 1);
          this.boxMove(event);
          return;
        }
        clearTimeout(this.ctrTimer);
        if (!time) {
          this.ctrTimer = null;
          this.showCtr = false;
        } else {
          this.showCtr = true;
          this.ctrTimer = setTimeout(() => {
            this.showControls(0);
          }, time);
        }
      },
      play() {
        if (this.playing) {
          this.player.pause();
        } else {
          this.player.play();
        }
      },
      onPlayerPlay(player) {
        player = this.isZcl ? this.$refs.ZclVideoPlayer[0] || this.$refs.ZclVideoPlayer : player;
        this.playing = true;
        this.$emit('play', player);
        if (this.isZcl) {
          this.onPlayerPlaying(player);
        }
      },
      onPlayerPlaying(player) {
        this.$emit('playing', player);
      },
      onPlayerTimeUpdate(player) {
        player = this.isZcl ? this.$refs.ZclVideoPlayer[0] || this.$refs.ZclVideoPlayer : player;
        this.currentTime = this.isZcl ? player.currentTime : player.currentTime();
        this.surplus = this.duration - this.currentTime;
        this.$emit('timeupdate', player);
      },
      async onPlayerEnded(player) {
        if (this.isZcl) {
          player = this.$refs.ZclVideoPlayer[0] || this.$refs.ZclVideoPlayer;
        }
        this.$emit('ended', player);
        if (this.userInfo.uid) {
          this.addPlayback();
        }
      },
      onPlayerPause(player) {
        player = this.isZcl ? this.$refs.ZclVideoPlayer[0] || this.$refs.ZclVideoPlayer : player;
        this.playing = false;
        this.$emit('pause', player);
        if (this.userInfo.uid) {
          this.addPlayback();
        }
      },
      fullScreen() {
        let el = document.documentElement;
        let full = [
          'requestFullscreen',
          'msRequestFullscreen',
          'mozRequestFullScreen',
          'webkitRequestFullscreen',
        ];
        let doc = document;
        let exit = [
          'exitFullscreen',
          'msExitFullscreen',
          'mozCancelFullScreen',
          'webkitExitFullscreen',
        ];
        if (this.isFullScreen) {
          // 退出全屏
          for (let e of exit) {
            if (doc[e]) {
              doc[e]();
              break;
            }
          }
        } else {
          // 全屏
          for (let e of full) {
            if (el[e]) {
              el[e]();
              break;
            }
          }
        }
      },
      setRate(text) {
        this.currMultiple = text;
        text = parseFloat(text);
        this.player.playbackRate(text);
      },
      winFullCallback(e) {
        this.isFullScreen = !!(document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
        this.$nextTick(() => this.boxWidth = this.$el.offsetWidth);
        this.$emit('full-screen', this.isFullScreen);
      },
      //////// 保存播放状态
      // 添加课时播放时长
      addPlayback() {
        let params = {
          is_web: '',
          uid: this.userInfo.uid,
          resource_id: this.rid,
          total_time: this.duration | 0,
          playback_time: this.currentTime | 0,
          is_https: '',
        };
        this.http.addResourceTime(params).then(res => {
          this.$emit('add-playback', params);
        }).catch(console.log);
      },
      // 添加播放时长记录
      addPlayTimes() {
        let params = {
          uid: this.userInfo.uid,
          resources_id: this.rid,
          times: this.duration | 0,
          ...this.Product,
        };
        this.http.addPlayTimes(params).then(res => {
          this.$emit('add-playtime', params);
        }).catch(console.log);
      },
      // 添加观看记录
      addRecord() {
        let params = {
          uid: this.userInfo.uid,
          resource_id: this.rid,
          type: 1,
          ...this.Product,
        };
        this.http.addPlayRecord(params).then(res => {
          this.$emit('add-record', params);
        }).catch(console.log);
      },
      // 添加课程播放记录
      addCourseRecord() {
        let params = {
          course_id: this.cid,
          ...this.Product,
        };
        this.http.addPlayCourse(params).then(res => {
          this.$emit('add-course-record', params);
        }).catch(console.log);
      }
    },
    created() {
			this.keyDownMethobs();
      // return;
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.winFullCallback);
    },
    mounted() {
      this.winFullCallback();
      window.removeEventListener('resize', this.winFullCallback);
      window.addEventListener('resize', this.winFullCallback);
    },
  }
</script>

<style scoped lang="less">
  @import "../../assets/less/function";

  @df-color: white;
  @act-color: #1177FF;

  /deep/ .vjs-error-display:before {
    display: none;
  }

  .pic-title {
    padding: 0 16px;
    font-size: 16px;
    color: @df-color;
    line-height: 1;
    height: 48px;
    background: linear-gradient(180deg, rgba(0, 15, 34, 0.5), rgba(0, 15, 34, 0));
    transform: translateY(-100%);
    transition: transform .3s;
  }

  .pic-play {
    width: 36px;
    height: 36px;
    left: 24px;
    bottom: 24px;
    transform: translateX(calc(-100% - 24px));
    transition: transform .3s;
    background-color: rgba(0, 15, 34, 0.52);
    border-radius: 8px;
  }

  .pic-box {
    &:hover {
      .pic-title {
        transform: translateY(0);
      }
      .pic-play {
        transform: translateX(0);
      }
    }
  }

  .video-icon {
    .spirit(url(../../assets/images/video_icon.png));
    &.close-ico {
      &:after {
        width: 26px;
        height: 26px;
        background-position: -7px -122px;
      }
    }
    &.play-ico {
      &:hover {
        &:after {
          background-position: -119px -10px;
        }
      }
      &:after {
        width: 32px;
        height: 32px;
        background-position: -83px -10px;
      }
    }
    &.pause-ico {
      &:hover {
        &:after {
          background-position: -47px -10px;
        }
      }
      &:after {
        width: 32px;
        height: 32px;
        background-position: -11px -10px;
      }
    }
    &.next-ico {
      &:hover {
        &:after {
          background-position: -191px -10px;
        }
      }
      &:after {
        width: 32px;
        height: 32px;
        background-position: -155px -10px;
      }
    }
    &.full-screen-ico {
      &:hover {
        &:after {
          background-position: -407px -10px;
        }
      }
      &:after {
        width: 32px;
        height: 32px;
        background-position: -371px -10px;
      }
    }
    &.sound-ico {
      &:hover {
        &:after {
          background-position: -263px -10px;
        }
      }
      &:after {
        width: 32px;
        height: 32px;
        background-position: -227px -10px;
      }
    }
    &.no-sound-ico {
      &:hover {
        &:after {
          background-position: -335px -10px;
        }
      }
      &:after {
        width: 32px;
        height: 32px;
        background-position: -299px -10px;
      }

    }

  }

  .full-screen-box {
    position: fixed;
    z-index: 10000;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #000;
    /deep/ .video-js.vjs-fluid {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .pic-box {
    position: fixed;
    width: 512px;
    z-index: 101;
    cursor: move;
    /deep/ .vjs-poster {
      cursor: unset;
    }
    .ctr-box,
    .bg-play {
      display: none;
    }
  }

  .ctr-box {
    bottom: -10px;
    height: 48px;
    background-color: rgba(0, 15, 34, .6);
    transition: transform .3s, bottom .3s;
    transform: translateY(100%);
    &.show-ctr {
      bottom: 0;
      transform: translateY(0);
    }
  }

  .other-slot {
    &.show-ctr {
      display: block;
    }
  }

  .ctr-inner {
    font-size: 14px;
    line-height: 32px;
    color: @df-color;
    > :nth-child(n) {
      > :nth-child(n) {
        &:hover,
        &.active {
          .top-tip {
            display: block;
            top: -16px;
            transform: translate(-50%, -100%);
          }
        }
      }
      > :not(.time-ctr) {
        cursor: pointer;
        &:hover,
        &.active {
          color: @act-color;
        }
      }
      > :not(:last-child) {
        margin-right: 16px;
      }
    }
    .time-ctr {
      margin-left: 24px;
    }
    .ctr-item {
      &:hover,
      &.active {
        .ctr-options,
        .set-sound {
          display: block;
          top: -16px;
          min-width: 80px;
          border-radius: 6px;
          background-color: rgba(0, 15, 34, 0.7);
          color: @df-color;
          transform: translate(-50%, -100%);
          // opacity: .6;
          &.set-sound {
            min-width: 40px;
            font-size: 12px;
            opacity: 1;
            background-color: rgba(0, 15, 34, .7);
          }
        }
      }
    }
    .ctr-options-row {
      padding: 0 8px;
      height: 32px;
      font-size: 14px;
      &:hover,
      &.active {
        font-size: 15px;
        color: @act-color;
      }
    }

    .set-sound {
      line-height: 24px;
      padding-bottom: 8px;
      top: 50px;
    }

    .set-sound-inner {
      // padding: 8px 0 13px;
      width: 40px;
      height: 100px;
      // background-color: rgba(255, 255, 255, .5);
      // border-radius: 2px;
      /*top: -16px;*/
      /*color: #fff;*/
      /*background-color: #000f22;*/
      /*opacity: .6;*/
      .sound-value{
        margin-bottom: 11px;
      }
      .after {
        max-height: 100%;
        background-color: @act-color;
      }
      .sound-circle {
        width: 10px;
        height: 10px;
        background-color: @df-color;
        border-radius: 50%;
        transform: translate(-50%, -5px);
      }
    }
  }

  .time-line {
    transform: translateY(-100%);
    height: 4px;
    background-color: rgba(229, 230, 232, .4);
    /*transition: height .3s;*/
    .load-time {
      max-width: 100%;
      background-color: rgba(229, 230, 232, .8);
    }
    .curr-time {
      background-color: @act-color;
      &-circle {
        position: absolute;
        top: 50%;
        width: 10px;
        height: 10px;
        background-color: @df-color;
        border-radius: 50%;
        transform: translate(-50%,-50%);
        z-index: 2;
        /*transition: width .3s, height .3s;*/
      }
    }
    .curr-time-num {
      opacity: 0;
      background-color: #000f22;
      transition: opacity .3s;
      .label-tip {
        top: -4px;
        padding: 0;
        width: 0;
        height: 0;
        transform: translate(-50%, -100%);
      }
    }
    &:hover {
      height: 12px;
      .curr-time-num {
        width: 1px;
        opacity: 1;
        .label-tip {
          padding: 0 8px;
          width: unset;
          height: unset;
        }
      }
      .curr-time-circle{
        width: 18px;
        height: 18px;
      }
    }
  }

  .end-box {
    padding: 0 86px;
    background: #000f22;
    z-index: 10;
		.end-replay{
			display: flex;
			align-items: center;
			.end-text {
			  color: @df-color;
			  padding: 63px 0 59px;
			}
			.pdt5{
				padding-top: 6px;
			}
			.rePlay{
				display: flex;
				color: @df-color;
				.icon-replay{
					height: 16px;
					width: 16px;
					margin-right: 5px;
				}
				&:hover{
				  font-size: 16px;
				  color: @act-color;
					cursor: pointer;
				}
			}
		}
    
    /deep/ .mine-no-data {
      width: 688px;
      .user-df-title {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
        margin-bottom: 16px;
      }
      .detail-box {
        color: rgba(255, 255, 255, 0.8);
      }
      .course-card {
        margin-bottom: 20px;
      }
    }
  }
  .not-next{
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: rgba(0, 15, 34, .7);
    border-radius: 4px;
    color: #fff;
    word-wrap: break-word;
    padding: 10px 18px;
  }
</style>
